import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "toast-container",
  "aria-live": "polite"
}

import { useToast } from '@/composables/useToast'
import AppToast from './AppToast.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ToastContainer',
  setup(__props) {

const { toasts, dismissToast } = useToast()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "toast-slide" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (t) => {
          return (_openBlock(), _createBlock(AppToast, {
            key: t.id,
            toast: t,
            onDismiss: _unref(dismissToast)
          }, null, 8, ["toast", "onDismiss"]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})